jQuery(document).ready(function() {
    jQuery('.reviews-list').slick({
        infinite: true,
        dots: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 5000,
    });
});